import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import CourseInformation from './courseInformation/CourseInformation';
import CourseBuilder from './courseBuilder/CourseBuilder';
import Publish from './publish/Publish';

const RenderSteps = () => {
    const { step } = useSelector(state => state.course);
    const steps = [
        {
            id: 1,
            title: 'Information',
            form: <CourseInformation />
        },
        {
            id: 2,
            title: 'Course Builder',
            form: <CourseBuilder />
        },
        {
            id: 3,
            title: 'Publish',
            form: <Publish />
        }
    ];

    return (
        <div className='flex flex-col gap-y-16'>
            <div className='mb-2 px-3 flex w-full justify-center'>
                {
                    steps.map((item) => (
                        <div key={item.id} className='flex items-center justify-center cursor-default'>
                            <div className='relative'>
                                <div className={`${step >= item.id ? 'bg-yellow-900 border-yellow-50 text-yellow-50' : 'border-richblack-700 bg-richblack-800 text-richblack-300'} aspect-square w-[34px] h-[34px] rounded-full border-[1px] transition-all duration-200 flex items-center justify-center`}>
                                    {step > item.id ? <FaCheck /> : item.id
                                    }
                                </div>
                                <div className='absolute top-10 min-w-[8rem] text-center right-0 -left-[2.6rem]'>
                                    <p className='text-sm'>{item.title}</p>
                                </div>
                            </div>
                            <div
                                className={
                                    `${step === 1 ? 'text-richblack-300' :
                                        step === 2 && item.id === 1 ? 'text-yellow-50' :
                                            step === 3 ? 'text-yellow-50' : 'text-richblack-300'} 
                                ${item.id === 3 && 'hidden'} flex justify-center items-center overflow-hidden leading-[0] h-1`}>
                                - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                            </div>
                        </div>
                    ))
                }
            </div>
            <div>
                {
                    steps[step - 1].form
                }
            </div>
        </div>
    );
}

export default RenderSteps;